var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Vue from 'vue';
import { BaseModule } from './../commons/BaseModule';
import EventBus from './models/EventBus';
var EventBusModule = (function (_super) {
    __extends(EventBusModule, _super);
    function EventBusModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bus = new EventBus();
        return _this;
    }
    EventBusModule.prototype.preInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            Vue.prototype.$eventBusOn = _this.bus.on.bind(_this.bus);
            Vue.prototype.$eventBusOff = _this.bus.off.bind(_this.bus);
            Vue.prototype.$eventBusEmit = _this.bus.emit.bind(_this.bus);
            resolve(true);
        });
    };
    EventBusModule.prototype.finalizeInstall = function (options) {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };
    return EventBusModule;
}(BaseModule));
export default EventBusModule;
export var EVENTS = {
    SESSION_EXPIRED: 'SESSION_EXPIRED',
    TEMPLATE_DESIGNER_SAVE: 'TEMPLATE_DESIGNER_SAVE',
    TEMPLATE_DESIGNER_SAVE_ERROR: 'TEMPLATE_DESIGNER_SAVE_ERROR',
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/eventbus/index.ts
// module id = null
// module chunks = 